import client from './client/initial-state'
import account from './account/initial-state'
import sharelink from './shareLink/initial-state'
import slideMenu from './slideMenu/initial-state'
import summaryEmail from './summaryEmail/initial-state'

export default { client, account, sharelink, slideMenu, summaryEmail }
